"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Transformation() {
  const {
    ref: revealRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const sectionRef = useRef<HTMLElement | null>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.bottom > 0 && rect.top < windowHeight) {
        const scrollProgress = (windowHeight - rect.top) * 0.1;
        setParallaxOffset(scrollProgress);
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="3912" id="ihr-projekt-hier" ref={sectionRef} className="bg-background text-foreground relative w-full overflow-hidden" style={{
    height: "90vh",
    minHeight: "640px"
  }}>
      {}
      <div className="absolute inset-0 w-full h-[120%] bg-cover bg-center bg-no-repeat will-change-transform bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/modern_web_agency_hero.webp)]" style={{
      transform: `translate3d(0, ${parallaxOffset}px, 0)`,
      top: "-10%"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 40%, hsla(0, 0%, 4%, 0.75) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(to bottom, transparent 0%, transparent 35%, hsla(43, 50%, 55%, 0.1) 75%, hsla(43, 50%, 55%, 0.2) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="relative z-10 h-full flex items-end justify-center pb-16 md:pb-24 px-6">
        <div ref={revealRef} className={`w-full max-w-[900px] mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex items-center justify-center gap-4 mb-8 md:mb-10">
            <span className="hidden sm:block h-px bg-primary/60" style={{
            width: "60px"
          }} aria-hidden="true" />
            <span className="font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase text-primary">
              — Orvo Web —
            </span>
            <span className="hidden sm:block h-px bg-primary/60" style={{
            width: "60px"
          }} aria-hidden="true" />
          </div>

          {}
          <h1 className="font-default font-light text-foreground mb-8 md:mb-10" style={{
          fontSize: "clamp(2.25rem, 6vw, 5.5rem)",
          lineHeight: "1.05",
          letterSpacing: "-0.01em"
        }}>
            Digitale Exzellenz für Ihr
            <br />
            <em className="italic font-serif text-primary">Unternehmen.</em>
          </h1>

          {}
          <p className="font-default text-foreground/80 mb-10 md:mb-12 max-w-xl mx-auto" style={{
          fontSize: "clamp(0.95rem, 1.2vw, 1.125rem)",
          lineHeight: "1.6"
        }}>
            Wir gestalten hochwertige, performante Websites in Oldenburg, die Ihre Marke digital erlebbar machen.
          </p>

          {}
          <div className="flex flex-col items-center gap-6">
            <Button asChild className="group bg-primary text-primary-foreground hover:bg-primary/90 px-8 md:px-10 py-5 h-auto text-sm md:text-base font-medium tracking-wide shadow-lg">
              <Link to="/ContactPage">
                <span>Jetzt kostenlose Ersteinschätzung anfragen</span>
                <ArrowRight className="ml-2 size-4 transition-transform duration-300 ease-out group-hover:translate-x-1" aria-hidden="true" />
              </Link>
            </Button>

            {}
            <Link to="/ContactPage" className="font-mono text-xs md:text-sm tracking-wide text-foreground/60 hover:text-primary transition-colors duration-300">
              Oder direkt Kontakt aufnehmen →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}